import { Component, OnInit, signal, computed } from '@angular/core';
import { BaseComponent } from '../../../../core/abstracts/baseComponent';
import { State } from '../../../../core/store';
import { Store } from '@ngrx/store';
import { loadHolidayYears, changeHolidayUserFilter, getHolidayList, showEditHoliday, saveHolidaySuccess, deleteHolidaySuccess } from '../../../../core/store/holiday/holiday.actions';
import { DropdownFilterService } from '../../../../core/services/dropdown-filter.service';
import { DateRangeModel } from '../../../../models/dateRangeModel';
import { PagingResultsModel } from '../../../../models/pagingResultsModel';
import { HolidayModel } from '../../../../models/holidayModel';
import { MonthModel } from '../../../../models/monthModel';
import { tap } from 'rxjs';
import { ofType, Actions } from '@ngrx/effects';
import { ModifiedSelectItem } from '../../../../models/utilModels';
import { getOptoLinkFromUrl } from '../../../../helpers/utils';

@Component({
    selector: 'app-list-holiday',
    templateUrl: './list-holiday.component.html',
    styleUrls: ['./list-holiday.component.scss'],
    standalone: false
})
export class ListHolidayComponent extends BaseComponent implements OnInit {
  holidays: PagingResultsModel<HolidayModel>;
  filter: any;

  loadingHolidayList: boolean = true;
  canEdit: boolean = false;
  canViewMassCancellations: boolean = false;

  holidayName: string = "";

  yearsList: ModifiedSelectItem[];
  year: number = 0;

  userList: ModifiedSelectItem[];
  userID: number = 0;

  monthList: MonthModel[];  
  month: number = -1;

  dateRangeList: DateRangeModel[];
  dateRange: DateRangeModel;
  startDate: string = null;
  endDate: string = null;
  isCustomDateRange: boolean = false;
  totalRecords = signal<number>(0);
  dropdownOptions = computed(() => {
    var total = this.totalRecords();
    return [
      { label: '20', value: 20 },
      { label: '50', value: 50 },
      { label: '100', value: 100 },
      { label: '200', value: 200 },
      { label: '500', value: 500 },
      { label: 'All', value: total > 0 ? total : 20 } 
    ];
  });
  constructor(
    private actions$: Actions,
    private store: Store<State>,
    private dropdownFilterService: DropdownFilterService) {
    super();
  }

  ngOnInit() {
    this.subs.push(
      this.store.select(s => s.holidayState.loadingHolidayList).subscribe(loadingHolidayList => {
        this.loadingHolidayList = loadingHolidayList;
      }),
      this.store.select(s => s.accountState.user?.permissionIDs).subscribe(permissionIDs => {
        this.canEdit = permissionIDs && !!permissionIDs.find(p => p === 3037);
        this.canViewMassCancellations = permissionIDs && !!permissionIDs.find(p => p === 3226 || p === 3227);
      }),
      this.store.select(s => s.holidayState.years).subscribe(years => {
        this.yearsList = years && years.length > 0 ? years
          : [{ label: 'loading...', value: undefined }];
      }),
      this.store.select(s => s.holidayState.filteredUsers).subscribe(userList => {
        this.userList = userList && userList.length > 0 ? userList
          : [{ label: 'loading...', value: undefined }];
      }),
      this.store.select(s => s.holidayState.holidayList).subscribe(holidayList => {
        this.holidays = holidayList;
        if(holidayList != null)
     	  	  	  this.totalRecords.set(holidayList.totalRecords);
      }),
      this.actions$.pipe(
        ofType(saveHolidaySuccess),
        tap(action => {
          this.reloadHolidays(this.filter);
        })
      ).subscribe(),
      this.actions$.pipe(
        ofType(deleteHolidaySuccess),
        tap(action => {
          this.reloadHolidays(this.filter);
        })
      ).subscribe(),
    );

    this.monthList = this.dropdownFilterService.getMonthsWithAll();
    if (this.monthList && this.monthList.length > 0) {
      this.month = this.monthList[0].value;
    }
    this.dateRangeList = this.dropdownFilterService.get30DayDateRanges();
    if (this.dateRangeList && this.dateRangeList.length > 0) {
      this.dateRange = this.dateRangeList[0];
    }
    this.store.dispatch(loadHolidayYears());
    this.store.dispatch(changeHolidayUserFilter());


  }

  changedDateRange() {
    if (this.dateRange.isCustom) {
      this.isCustomDateRange = true;
      return; //reload after manually changing date
    }

    this.isCustomDateRange = false;
    this.startDate = this.dateRange.startDate;
    this.endDate = this.dateRange.endDate;
    this.reloadHolidays(this.filter);
  }

  reloadHolidays(event) {
    this.filter = event;
    this.store.dispatch(getHolidayList({
      filter: this.filter,
      holidayName: this.holidayName,
      year: this.year,
      month: this.month,
      userID: this.userID,
      startDate: this.startDate,
      endDate: this.endDate
    }));
  }

  editHoliday(holiday) {
    this.store.dispatch(showEditHoliday({ holiday: holiday}));
  }

  goToMassCancellationsUrl() {
    window.location.href = getOptoLinkFromUrl() + "/Scheduling/Cancellation/MassCancellations";
  }
}
